// src/StaffsDataContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config';


const StaffsDataContext = createContext();

export function StaffDataProvider({ children }) {
  const [staffData, setStaffData] = useState([]);
  const [loading, setLoading] = useState(false);

  
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.apiBaseUrl}/staffs/getAllStaffs.php`);
      const data = await response.json();
      setStaffData(data);
    } catch (error) {
      console.error('Error fetching fee data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const refreshStaffData = () => {
    fetchData();
  };

  return (
    <StaffsDataContext.Provider value={{ staffData, loading, refreshStaffData }}>
      {children}
    </StaffsDataContext.Provider>
  );
}

export function useStaffData() {
  const context = useContext(StaffsDataContext);
  if (context === undefined) {
    throw new Error('useStaffData must be used within a StaffDataProvider');
  }
  return context;
}
